import { TrustReconciliationLayout } from './layouts';
import { TrustDashboardView } from './components/TrustDashboardView';

export function TrustDashboardPage() {
  return (
    <TrustReconciliationLayout>
      <TrustDashboardView />
    </TrustReconciliationLayout>
  );
}
